const pluralize = (quantity: number, pluralPhrase: string, singularPhrase: string): string => {
    if (quantity === 1) {
        return singularPhrase;
    }

    return pluralPhrase;
};

export default pluralize;
